module.exports = __webpack_public_path__ + "img/image (9).d2c13682.webp";